module.exports = "/lucky-balls/img/combos/6.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos/6.png
// module id = 1003
// module chunks = 0